import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { endpoints } from '../config/apiConfig';
import { useNavigate } from 'react-router-dom';
import NavbarAdmin from './NavbarAdmin';


const DashboardEstadisticas = () => {
    const navigate = useNavigate();
    const [loadingStates, setLoadingStates] = useState({
        metricas: true,
        tabla: true
    });
    const [error, setError] = useState('');
    const [estadisticas, setEstadisticas] = useState({
        totalEstudiantes: 0,
        totalRevision: 0,
        totalSinRevision: 0
    });
    const [globalFilter, setGlobalFilter] = useState('');
    const [programas, setProgramas] = useState([]);

    const LoaderCard = () => (
        <div className="flex items-center justify-center h-32">
            <div className="animate-spin h-8 w-8 border-3 border-blue-500 rounded-full border-t-transparent"></div>
        </div>
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userRole = localStorage.getItem('userRole');
                if (userRole !== '1') {
                    navigate('/loginUsuario');
                    return;
                }

                const response = await fetch(endpoints.estadisticasRevision(2));
                const data = await response.json();

                if (!data.success) {
                    throw new Error('Error al obtener datos');
                }

                setEstadisticas(data.data.totalesGenerales);
                setProgramas(data.data.programas);
                
                setLoadingStates({
                    metricas: false,
                    tabla: false
                });
            } catch (error) {
                console.error('Error:', error);
                setError('Error al cargar los datos');
                setLoadingStates({
                    metricas: false,
                    tabla: false
                });
            }
        };

        fetchData();
    }, [navigate]);

    const porcentajeTemplate = (rowData) => {
        const porcentaje = (rowData.totalRevision / rowData.totalEstudiantes) * 100 || 0;
        return `${porcentaje.toFixed(1)}%`;
    };

    return (
        <>
            <NavbarAdmin />
            <div className="bg-gray-100 min-h-screen p-8">
                <div className="max-w-7xl mx-auto">
                    <h1 className="text-2xl font-bold text-gray-800 mb-6">Estadísticas de Revisión de Matrícula</h1>
                    
                    {error && (
                        <div className="p-4 mb-4 text-red-700 bg-red-100 rounded">
                            {error}
                        </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                        <Card className="bg-blue-50 shadow-md">
                            {loadingStates.metricas ? (
                                <LoaderCard />
                            ) : (
                                <div className="text-center">
                                    <h3 className="text-lg font-semibold text-blue-700 mb-2">Total Estudiantes</h3>
                                    <p className="text-3xl font-bold text-blue-600">{estadisticas.totalEstudiantes}</p>
                                </div>
                            )}
                        </Card>

                        <Card className="bg-green-50 shadow-md">
                            {loadingStates.metricas ? (
                                <LoaderCard />
                            ) : (
                                <div className="text-center">
                                    <h3 className="text-lg font-semibold text-green-700 mb-2">Revisiones Completadas</h3>
                                    <p className="text-3xl font-bold text-green-600">{estadisticas.totalRevision}</p>
                                </div>
                            )}
                        </Card>

                        <Card className="bg-red-50 shadow-md">
                            {loadingStates.metricas ? (
                                <LoaderCard />
                            ) : (
                                <div className="text-center">
                                    <h3 className="text-lg font-semibold text-red-700 mb-2">Pendientes por Revisar</h3>
                                    <p className="text-3xl font-bold text-red-600">{estadisticas.totalSinRevision}</p>
                                </div>
                            )}
                        </Card>
                    </div>

                    <div className="bg-white rounded-lg shadow-md p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-xl font-semibold">Resumen por Programas</h2>
                            <div className="p-input-icon-left">
                                <input
                                    type="search"
                                    className="p-inputtext p-component p-filled w-64 px-3 py-2 border rounded"
                                    placeholder="Buscar programa..."
                                    onChange={(e) => setGlobalFilter(e.target.value)}
                                />
                            </div>
                        </div>
                        {loadingStates.tabla ? (
                            <div className="flex items-center justify-center h-64">
                                <div className="animate-spin h-12 w-12 border-4 border-blue-500 rounded-full border-t-transparent"></div>
                            </div>
                        ) : (
                            <DataTable 
                                value={programas}
                                responsiveLayout="scroll"
                                className="p-datatable-sm"
                                showGridlines
                                stripedRows
                                sortField="programa"
                                sortOrder={1}
                                globalFilter={globalFilter}
                                emptyMessage="No se encontraron programas"
                            >
                                <Column field="programa" header="Programa" sortable />
                                <Column field="totalEstudiantes" header="Total Estudiantes" sortable />
                                <Column field="totalRevision" header="Revisados" sortable />
                                <Column field="totalSinRevision" header="Pendientes" sortable />
                                <Column body={porcentajeTemplate} header="Progreso" sortable />
                            </DataTable>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default DashboardEstadisticas;